(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var form = document.querySelector('[data-cart-form]');
    if (!form) return;

    var checkbox = form.querySelector('[data-cart-acceptance-checkbox]');
    var buttonsWrapper = form.querySelector('[data-cart-checkout-buttons]');
    var submitButton = buttonsWrapper ? buttonsWrapper.querySelector('button[type="submit"][name="checkout"]') : null;
    var errorMessage = form.querySelector('[data-terms-error-message]');

    if (!checkbox || !buttonsWrapper || !submitButton) return;

    function setStateFromCheckbox() {
      var checked = checkbox.checked;
      buttonsWrapper.classList.toggle('cart__buttons--disabled', !checked);
      submitButton.disabled = !checked;
      submitButton.setAttribute('aria-disabled', !checked ? 'true' : 'false');
      if (errorMessage && checked) {
        errorMessage.textContent = '';
      }
    }

    setStateFromCheckbox();

    checkbox.addEventListener('change', function () {
      setStateFromCheckbox();
    });

    form.addEventListener('submit', function (event) {
      if (!checkbox.checked) {
        event.preventDefault();
        if (errorMessage) {
          var text = errorMessage.getAttribute('data-terms-error-text');
          if (text) {
            errorMessage.textContent = text;
          }
        }
        checkbox.focus();
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var form = document.querySelector('[data-cart-form]');
    if (!form) return;

    var checkbox = form.querySelector('[data-cart-acceptance-checkbox]');
    var buttonsWrapper = form.querySelector('[data-cart-checkout-buttons]');
    var submitButton = buttonsWrapper ? buttonsWrapper.querySelector('button[type="submit"][name="checkout"]') : null;
    var errorMessage = form.querySelector('[data-terms-error-message]');

    if (!checkbox || !buttonsWrapper || !submitButton) return;

    function setStateFromCheckbox() {
      var checked = checkbox.checked;
      buttonsWrapper.classList.toggle('cart__buttons--disabled', !checked);
      submitButton.disabled = !checked;
      submitButton.setAttribute('aria-disabled', !checked ? 'true' : 'false');
      if (errorMessage && checked) {
        errorMessage.textContent = '';
      }
    }

    setStateFromCheckbox();

    checkbox.addEventListener('change', function () {
      setStateFromCheckbox();
    });

    form.addEventListener('submit', function (event) {
      if (!checkbox.checked) {
        event.preventDefault();
        if (errorMessage) {
          var text = errorMessage.getAttribute('data-terms-error-text');
          if (text) {
            errorMessage.textContent = text;
          }
        }
        checkbox.focus();
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["popup-banner-wpp-custom"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var root = document.getElementById('popup-banner');
    if (!root) return;

    var rule = root.getAttribute('data-display-rule');
    var frequencyDays = parseInt(root.getAttribute('data-frequency-days') || '0', 10);
    var startDate = root.getAttribute('data-start-date');
    var endDate = root.getAttribute('data-end-date');
    var storageKey = 'popup-banner-' + root.getAttribute('data-section-id');

    function inDateRange() {
      var now = new Date();
      if (startDate) {
        var start = new Date(startDate);
        if (now < start) return false;
      }
      if (endDate) {
        var end = new Date(endDate);
        end.setHours(23, 59, 59, 999);
        if (now > end) return false;
      }
      return true;
    }

    function shouldShow() {
      if (!inDateRange()) return false;

      if (rule === 'always') return true;

      try {
        var stored = JSON.parse(localStorage.getItem(storageKey) || 'null');
        if (!stored) return true;

        var last = new Date(stored.lastShown);
        if (rule === 'once') {
          return false;
        }

        if (rule === 'interval' && frequencyDays > 0) {
          var diffMs = Date.now() - last.getTime();
          var diffDays = diffMs / (1000 * 60 * 60 * 24);
          return diffDays >= frequencyDays;
        }
      } catch (e) {}

      return true;
    }

    function markShown() {
      try {
        localStorage.setItem(storageKey, JSON.stringify({ lastShown: new Date().toISOString() }));
      } catch (e) {}
    }

    function show() {
      if (!shouldShow()) return;

      function reveal() {
        root.hidden = false;
      }

      if (document.startViewTransition) {
        document.startViewTransition(reveal);
      } else {
        reveal();
      }

      markShown();
    }

    function hide() {
      root.hidden = true;
    }

    var closeBtn = root.querySelector('.popup-banner__close');
    if (closeBtn) {
      closeBtn.addEventListener('click', hide);
    }

    root.addEventListener('click', function(event) {
      if (event.target === root.querySelector('.popup-banner__backdrop')) {
        hide();
      }
    });

    document.addEventListener('keydown', function(event) {
      if (event.key === 'Escape') {
        hide();
      }
    });

    if (document.readyState === 'complete' || document.readyState === 'interactive') {
      show();
    } else {
      document.addEventListener('DOMContentLoaded', show);
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
